<template>
  <div class="galery-page">
    <!-- HERO -->
    <section
      class="galery-hero text-center d-flex align-items-end justify-content-center pb-md-5 pb-2"
    >
      <div>
        <h1 class="fw-bold title-page">Galeri Kegiatan Gaharu Outbound</h1>
        <p class="lead-page text-success">Momen seru dan penuh kebersamaan</p>
      </div>
    </section>

    <!-- CONTENT -->
    <div class="container py-5">
      <div class="cta-box mb-4 text-start">
        <div>
          <h4 class="fw-bold text-success mb-2">
            Butuh bantuan memilih paket?
          </h4>
          <p class="mb-0">
            Konsultasi gratis via WhatsApp dan dapatkan rekomendasi paket yang
            paling cocok.
          </p>
        </div>
        <button
          type="button"
          class="btn btn-success fw-semibold"
          @click="
            handleWhatsAppClick({
              title: 'Konsultasi paket outbound',
              service: selectedService || 'semua paket',
            })
          "
        >
          <i class="bi bi-whatsapp me-2"></i>
          Tanya Via WhatsApp
        </button>
      </div>

      <!-- SORT BUTTON -->
      <div class="d-flex justify-content-end mb-4">
        <div class="sort-buttons">
          <button
            :class="['sort-btn', sortOrder === 'newest' ? 'active' : '']"
            @click="setSort('newest')"
          >
            Terbaru
          </button>

          <button
            :class="['sort-btn', sortOrder === 'oldest' ? 'active' : '']"
            @click="setSort('oldest')"
          >
            Terlama
          </button>
        </div>
      </div>

      <!-- LOADING -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-grow text-warning"></div>
        <div class="spinner-grow text-success"></div>
        <div class="spinner-grow text-warning"></div>
        <div class="spinner-grow text-success"></div>
        <p class="mt-3">Memuat galeri...</p>
      </div>

      <!-- ERROR -->
      <div v-if="error" class="text-center text-danger py-5">
        {{ error }}
      </div>

      <!-- GRID -->
      <div v-if="!loading && galleryImages.length" class="row g-4">
        <div
          v-for="(imgObj, idx) in galleryImages"
          :key="idx"
          class="col-12 col-md-4 col-lg-3"
        >
          <div class="gallery-item" @click="openModal(imgObj)">
            <!-- IMAGE WRAPPER -->
            <div class="gallery-image">
              <img :src="imgObj.src" loading="lazy" />
            </div>

            <!-- WATERMARK -->
            <div class="watermark">
              <img src="../../../assets/logo_gaharu_white.png" />
            </div>

            <!-- OVERLAY -->
            <div class="gallery-overlay">
              <h5>{{ imgObj.gallery.title }}</h5>

              <small>
                {{ imgObj.gallery.location }}
                <br />
                {{ formatDate(imgObj.gallery.date) }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- EMPTY -->
      <div v-if="!loading && !galleryImages.length" class="text-center py-5">
        Belum ada galeri tersedia.
      </div>

      <!-- PAGINATION -->
      <div v-if="totalPage > 1" class="custom-pagination">
        <button
          class="nav-btn"
          :disabled="currentPage === 1"
          @click="changePage(currentPage - 1)"
        >
          ‹
        </button>

        <button
          v-for="page in totalPage"
          :key="page"
          class="page-number"
          :class="{ active: currentPage === page }"
          @click="changePage(page)"
        >
          {{ page }}
        </button>

        <button
          class="nav-btn"
          :disabled="currentPage === totalPage"
          @click="changePage(currentPage + 1)"
        >
          ›
        </button>
      </div>
    </div>

    <!-- MODAL -->
    <div class="modal fade" tabindex="-1" ref="modalRef">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content border-0">
          <div class="modal-body p-0 text-center">
            <img
              v-if="selectedImage"
              :src="selectedImage"
              class="img-fluid w-100 rounded-top"
            />

            <div class="watermark modal-watermark">
              <img src="../../../assets/logo_gaharu_white.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from "vue";
import { Modal } from "bootstrap";

import { useMeta } from "@/composables/useMeta";

export default {
  setup() {
    const galleryImages = ref([]);
    const loading = ref(false);
    const error = ref(null);

    const selectedImage = ref(null);
    const modalRef = ref(null);
    let modalInstance = null;

    const currentPage = ref(1);
    const totalPage = ref(1);
    const limit = 12;

    const sortOrder = ref("newest");

    const { trackMetaEvent, buildWhatsAppLink } = useMeta();

    const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

    const fetchGallery = async () => {
      try {
        loading.value = true;

        const response = await fetch(
          `${API_BASE_URL}/api/galeries/images?page=${currentPage.value}&limit=${limit}&sort=${sortOrder.value}`,
        );

        const result = await response.json();

        totalPage.value = result.totalPage;

        galleryImages.value = result.data.map((item) => ({
          src: item.img_url,
          gallery: item.galery,
        }));
      } catch (err) {
        console.error(err);
        error.value = "Gagal memuat galeri.";
      } finally {
        loading.value = false;
      }
    };

    const setSort = (order) => {
      if (sortOrder.value === order) return;

      sortOrder.value = order;
      currentPage.value = 1;

      fetchGallery();
    };

    const changePage = (page) => {
      if (page < 1 || page > totalPage.value) return;

      currentPage.value = page;

      fetchGallery();

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    const openModal = async (imgObj) => {
      selectedImage.value = imgObj.src;

      await nextTick();

      if (!modalInstance) {
        modalInstance = new Modal(modalRef.value);
      }

      modalInstance.show();
    };

    const formatDate = (date) => {
      if (!date) return "";

      return new Date(date).toLocaleDateString("id-ID");
    };

    /* WHATSAPP */

    const handlePackageView = (pricelist) => {
      trackMetaEvent("ViewContent", {
        content_name: pricelist.title,
        content_category: pricelist.service?.name || "price-list",
        content_type: "pricelist_item",
      });
    };

    const handleWhatsAppClick = (pricelist) => {
      const title = pricelist?.title || "paket outbound";
      const service = pricelist?.service?.name || "";
      const link = buildWhatsAppLink({
        title,
        service,
        source: "price-list-page",
      });

      trackMetaEvent("Lead", {
        content_name: title,
        content_category: service || "price-list",
        content_type: "whatsapp_click",
      });

      window.open(link, "_blank", "noopener,noreferrer");
    };

    onMounted(fetchGallery);

    return {
      galleryImages,
      loading,
      error,

      selectedImage,
      modalRef,

      openModal,
      formatDate,

      currentPage,
      totalPage,
      changePage,

      sortOrder,
      setSort,
      handlePackageView,
      handleWhatsAppClick,
    };
  },
};
</script>

<style scoped>
/* CTA */

.cta-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 16px;
  background: linear-gradient(135deg, #fff8e1, #f5fff7);
  border: 1px solid #d8f2dc;
}

/* FILTER BUTTON */

.service-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.filter-btn {
  border: none;
  background: white;
  color: #198754;

  padding: 6px 14px;
  border-radius: 5px;

  font-weight: 600;
  font-size: 14px;

  cursor: pointer;

  transition: 0.3s;
}

.filter-btn:hover {
  background: #198754;
  color: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.filter-btn.active {
  background: #198754;
  color: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

.galery-hero {
  height: 300px;
  background: url("../../../assets/bg-home.webp") center/cover no-repeat;
}

.title-page {
  font-size: 40px;
}

.lead-page {
  font-size: 20px;
}

/* SORT BUTTON */

.sort-buttons {
  display: flex;
  gap: 8px;
}

.sort-btn {
  border: none;
  background: white;
  color: #198754;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s;
}

.sort-btn:hover {
  background: #198754;
  color: white;
}

.sort-btn.active {
  background: #198754;
  color: white;
}

/* GALLERY */

.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
}

/* IMAGE RATIO FIX (WORKS ON iPhone) */

.gallery-image {
  width: 100%;
  aspect-ratio: 4/3;
  overflow: hidden;
}

.gallery-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.gallery-item:hover img {
  transform: scale(1.1);
}

/* OVERLAY */

.gallery-overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 15px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: white;
  opacity: 0;
  transition: opacity 0.3s;
}

.gallery-item:hover .gallery-overlay {
  opacity: 1;
}

/* WATERMARK */

.watermark {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 2;
  pointer-events: none;
}

.watermark img {
  height: 20px;
  width: auto;
  display: block;
}

.modal-watermark img {
  height: 40px;
}

/* PAGINATION */

.custom-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 40px;
}

.page-number,
.nav-btn {
  border: none;
  background: #f1f1f1;
  color: #333;
  min-width: 40px;
  height: 40px;
  border-radius: 10px;
}

.page-number:hover,
.nav-btn:hover {
  background: #198754;
  color: white;
}

.page-number.active {
  background: #198754;
  color: white;
}

/* MOBILE */

@media (max-width: 768px) {
  .galery-hero {
    height: 200px;
  }

  .title-page {
    font-size: 25px;
  }

  .lead-page {
    font-size: 12px;
  }
}
</style>
